module.exports = __webpack_public_path__ + "media/components/icons/SVG/layersneeded-f81f86565e5df98448541de888d42170.svg";